import classnames from 'classnames';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'ramda';
import { Portal } from 'react-portal';

import withBoundingClientRect from './hoc/withBoundingClientRect';

const List = ({ children, boundingClientRect, width, alignment }) => (
  <ul
    className={classnames('c-dropdown s-v2', { 'is-active': !isEmpty(children) })}
    style={{
      top: alignment === 'bottom' ? boundingClientRect.bottom : boundingClientRect.top,
      left: alignment === 'left' || alignment === 'bottom' ? boundingClientRect.left : undefined,
      right: alignment === 'right' ? (document.body.clientWidth - boundingClientRect.right || 0) : undefined,
      minWidth: boundingClientRect.width,
      width,
    }}
  >
    {children}
  </ul>
);

List.propTypes = {
  children: PropTypes.arrayOf(PropTypes.any),
  boundingClientRect: PropTypes.object.isRequired,
  width: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'right', 'bottom']),
};

List.defaultProps = {
  children: [],
  width: null,
  alignment: 'left',
};

const Dropdown = props => (
  <div>
    <Portal>
      <List {...props} />
    </Portal>
  </div>
);

const Item = props => (
  <li className="c-dropdown__item" {...props} />
);

const Container = compose(withBoundingClientRect)(Dropdown);
Container.Item = Item;

export default Container;
